import React from 'react';
import {
  makeStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import config from '../../config/config';

const useStyles = makeStyles(() => ({
  therapistMugshot: {
    display: 'block',
    maxWidth: '100%',
  },
}));

const TherapistProfilePicture = (props) => {
  const { therapist } = props;
  const classes = useStyles();

  if (therapist.image && (therapist.image !== 'NULL')) {
    return (
      <img
        className={classes.therapistMugshot}
        src={`${config[process.env.APP_ENV].imageStorage}${therapist.image}`}
        alt=""
      />
    );
  }

  if (therapist.sex) {
    return (
      <img
        className={classes.therapistMugshot}
        src="/static/images/man.png"
        alt=""
      />
    );
  }

  return (
    <img
      className={classes.therapistMugshot}
      src="/static/images/woman.png"
      alt=""
    />
  );
};

TherapistProfilePicture.propTypes = {
  therapist: PropTypes.shape({
    image: PropTypes.string,
    sex: PropTypes.number,
  }).isRequired,
};

export default TherapistProfilePicture;
